import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Radio, GitBranch, ShieldAlert, BarChart3, Users, LogOut, Zap, Settings } from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV = [
  { id: "copilot", label: "Copiloto Ao Vivo", path: "/copilot", icon: Radio, badge: "LIVE", testId: "nav-link-copilot" },
  { id: "funnels", label: "Funil & Guiões", path: "/funnels", icon: GitBranch, testId: "nav-link-funnels" },
  { id: "objections", label: "Objeções", path: "/objections", icon: ShieldAlert, testId: "nav-link-objections" },
  { id: "history", label: "Histórico", path: "/history", icon: BarChart3, testId: "nav-link-history" },
  { id: "team", label: "Equipa", path: "/team", icon: Users, testId: "nav-link-team" },
  { id: "admin", label: "Admin", path: "/admin", icon: Settings, testId: "nav-link-admin", adminOnly: true },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen grain-bg">
      <header className="glass border-b border-white/10 sticky top-0 z-50">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 flex items-center gap-4 h-16">
          <button
            onClick={() => navigate("/copilot")}
            className="flex items-center gap-2.5 shrink-0"
            data-testid="brand-logo"
          >
            <div className="w-9 h-9 rounded-xl bg-[#2563EB] flex items-center justify-center">
              <Zap className="w-5 h-5 text-white" fill="white" />
            </div>
            <div className="hidden sm:block text-left leading-none">
              <div className="font-display font-extrabold text-lg tracking-tight">PitchPulse AI</div>
              <div className="cue-label text-[#64748B]">Copiloto de Vendas</div>
            </div>
          </button>

          <nav className="flex-1 flex items-center gap-1 overflow-x-auto no-scrollbar">
            {NAV.filter((it) => !it.adminOnly || user?.role === "admin").map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.id}
                  to={item.path}
                  data-testid={item.testId}
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                      isActive
                        ? "bg-[#2563EB] text-white"
                        : "text-[#94A3B8] hover:text-white hover:bg-white/5"
                    }`
                  }
                >
                  <Icon className="w-4 h-4" />
                  <span className="hidden md:inline">{item.label}</span>
                  {item.badge && (
                    <span className="text-[9px] font-mono px-1.5 py-0.5 rounded bg-[#EF4444] text-white tracking-wider">
                      {item.badge}
                    </span>
                  )}
                </NavLink>
              );
            })}
          </nav>

          <div className="flex items-center gap-3 shrink-0">
            <div className="hidden lg:block text-right leading-tight">
              <div className="text-sm font-medium text-white">{user?.name}</div>
              <div className="text-xs text-[#64748B] capitalize">{user?.role}</div>
            </div>
            <div className="w-9 h-9 rounded-full bg-[#1A2234] border border-white/10 flex items-center justify-center text-sm font-semibold text-[#2563EB]">
              {user?.name?.[0]?.toUpperCase() || "?"}
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={logout}
              data-testid="logout-button"
              className="text-[#94A3B8] hover:text-white hover:bg-white/5"
              title="Terminar sessão"
            >
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-[1600px] mx-auto px-4 sm:px-6 py-6">{children}</main>
    </div>
  );
}
